


































































































































































































import {
  ADD_DISH_MODIFIER,
  DELETE_DISH_MODIFIER,
  DELETE_MODIFIER,
  UPDATE_DISH_MODIFIER_SORT_INDEX,
} from "@/queries/user/mutation.graphql";
import { GET_MENU_DISHES, GET_MODIFIERS } from "@/queries/user/query.graphql";
import Vue from "vue";
import AddEditModifier from "./AddEditModifier.vue";
import deleteMenuItemConfirmation from "@/views/dashboard/deleteMenuItemConfirmation.vue";
export default Vue.extend({
  props: {
    dishModifiers: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      addModifier: false,
      value: [],
      modifiers: null,
      selectedModifier: null,
      openDeleteConfirmation: false,
      deleteMode: null,
      selectedForDelete: null,
    };
  },
  apollo: {
    modifiers: {
      query: GET_MODIFIERS,
      update: (data) => data.Modifier,
    },
  },
  methods: {
    onSelectModifier(option, id) {
      const sortIndex = this.value.length;
      this.$apollo.mutate({
        mutation: ADD_DISH_MODIFIER,
        variables: {
          modifierId: option.id,
          dishId: this.$store.getters["userModule/dishId"],
          sortIndex,
        },
        update: (cache, { data: { insert_DishModifier } }) => {
          if (insert_DishModifier.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: this.$store.getters["userModule/dishId"],
              },
            });

            data.Dish[0].DishModifiers.push({
              __typename: "DishModifier",
              Modifier: option,
              id: insert_DishModifier.returning[0].id,
              sortIndex,
            });
            cache.writeQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: this.$store.getters["userModule/dishId"],
              },
              data,
            });
          }
        },
      });
    },
    onDiselectModifier(option, id) {
      this.$apollo.mutate({
        mutation: DELETE_DISH_MODIFIER,
        variables: {
          id: option.id,
          dishId: this.$store.getters["userModule/dishId"],
        },
        update: (cache, { data: { delete_DishModifier } }) => {
          if (delete_DishModifier.affected_rows) {
            const data: any = cache.readQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: this.$store.getters["userModule/dishId"],
              },
            });
            data.Dish[0].DishModifiers = data.Dish[0].DishModifiers.filter(
              (el) => el.Modifier.id !== option.id
            );

            cache.writeQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: this.$store.getters["userModule/dishId"],
              },
              data,
            });
          }
        },
      });
    },
    updateDishModifierSortIndex() {
      console.log(this.value);

      const objects = this.value.map((el: any, index) => {
        el.sortIndex = index;
        return {
          sortIndex: index,
          modifierId: el.id,
          // id: el._dishModifierid,
          dishId: this.$store.getters["userModule/dishId"],
        };
      });
      console.log(objects);
      this.$apollo.mutate({
        mutation: UPDATE_DISH_MODIFIER_SORT_INDEX,
        variables: { objects },
        update: (cache, { data: { insert_DishModifier } }) => {
          if (insert_DishModifier.affected_rows) {
            console.log(insert_DishModifier);

            const data: any = cache.readQuery({
              query: GET_MENU_DISHES,
              variables: {
                // dishId: this.$route.params.itemId,
                dishId: this.$store.getters["userModule/dishId"],
              },
            });
            data.Dish[0].DishModifiers = this.value.map((element, index) => {
              const { _dishModifierid: id, sortIndex, ...rest } = element;
              return {
                Modifier: rest,
                id,
                sortIndex,
                __typename: "DishModifier",
              };
            });
            console.log(data.Dish[0].DishModifiers);
            cache.writeQuery({
              query: GET_MENU_DISHES,
              variables: {
                dishId: this.$store.getters["userModule/dishId"],
              },
              data,
            });
          }
        },
      });
    },
    deselectDishModifier(selected) {
      this.deleteMode = "dishModifier";
      this.selectedForDelete = selected;
      this.onDelete();
    },
    onSelectForDelete(selected, mode) {
      this.deleteMode = mode;
      this.selectedForDelete = selected;
      this.openDeleteConfirmation = true;
    },
    onDelete() {
      if (this.deleteMode === "modifier") {
        //modifier

        this.openDeleteConfirmation = false;
        this.$apollo
          .mutate({
            mutation: DELETE_MODIFIER,
            variables: {
              id: this.selectedForDelete.id,
            },
            update: (cache, { data: { delete_Modifier } }) => {
              if (delete_Modifier.affected_rows) {
                const data: any = cache.readQuery({
                  query: GET_MODIFIERS,
                });
                data.Modifier = data.Modifier.filter(
                  (el) => el.id !== this.selectedForDelete.id
                );
                cache.writeQuery({
                  query: GET_MODIFIERS,
                  data,
                });
              }
            },
          })
          .then(() => this.$toastr.s("Deleted successfuly"))
          .catch(() => this.$toastr.s("Error"));
      } else {
        //dishModifier

        this.openDeleteConfirmation = false;
        this.$apollo.mutate({
          mutation: DELETE_DISH_MODIFIER,
          variables: {
            id: this.selectedForDelete.id,
            dishId: this.$store.getters["userModule/dishId"],
          },
          update: (cache, { data: { delete_DishModifier } }) => {
            if (delete_DishModifier.affected_rows) {
              const data: any = cache.readQuery({
                query: GET_MENU_DISHES,
                variables: {
                  dishId: this.$store.getters["userModule/dishId"],
                },
              });
              data.Dish[0].DishModifiers = data.Dish[0].DishModifiers.filter(
                (el) => el.Modifier.id !== this.selectedForDelete.id
              );
              cache.writeQuery({
                query: GET_MENU_DISHES,
                variables: {
                  dishId: this.$store.getters["userModule/dishId"],
                },
                data,
              });
            }
          },
        });
      }
    },
  },
  components: {
    AddEditModifier,
    deleteMenuItemConfirmation,
  },
  mounted() {
    this.value = this.dishModifiers.map((el: any) => ({
      ...el.Modifier,
      _dishModifierid: el.id,
      sortIndex: el.sortIndex,
    }));
  },
  watch: {
    dishModifiers() {
      this.value = this.dishModifiers.map((el: any) => ({
        ...el.Modifier,
        _dishModifierid: el.id,
        sortIndex: el.sortIndex,
      }));
    },
  },
});
